import axios from 'axios';
import * as CookieService from '../Cookie/CookieService';

export function getTeacherList(userName, pageVO) {
    let setParam = '/api/v1/user/teacherpaging?';
    if(userName != null) {
    	setParam += '&userName=' + userName;
    }
    if (pageVO != null) {
        setParam += '&page=' + pageVO.page + '&size=' + pageVO.size + '&sort=' + pageVO.sortBy + ',' + pageVO.direction;
    }console.log(setParam);
    return axios.get(setParam, CookieService.setHeaders());
}

export function updateUserAuthority(userName, identity) {
    const requestParams = {
	    params: {
		"username": userName,
		"identity": identity,
		"authority": (identity === 'I_ADMIN')? 'BEACON_ADMIN' : 'BEACON_USER'
	    },
	    headers: CookieService.setHeader()
    };
    return axios.get('/api/v1/user/authority', requestParams);
}


// WEBPACK FOOTER //
// ./src/services/Teacher/AdminTeacherService.js